export default "__VITE_ASSET__232076ad__"